import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography, useMediaQuery, Box, useTheme } from '@mui/material'
import Parser from 'html-react-parser';
import useSwiper from "use-swiper";
import { useTranslation } from 'react-i18next';

//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './LifeTestStyles'
import { fileActions } from '../../store/actions'//Acciones para redux
import { GenericDialog, UseImage, Buttons } from '../../components'
import iconLifet1Img from '../../assets/iconLifet1.png'
import pruebaVidaSonrieImg from '../../assets/pruebaVidaSonrie.png'

export default function LifeTestHelp(props) {
    const theme = useTheme()
    const location = useLocation()
    const windowHeight = window.innerHeight;
    const matches = useMediaQuery('(max-width:812px)')
    const localStyles = useStyles();
    // const navigate = useNavigate();
    const { t } = useTranslation();

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    const file = useSelector(state => state.FileInfo);
    const typeSeflie = file?.items?.Stage?.Properties.find((type) => type.Name == "GetFaceCaptureNumber")
    const typeAmbiente = file?.items?.Stage?.Properties.find((type) => type.Name == "ProofOfLifeValidationType");

    console.log("----------*******typeAmbiente****-----------: ", typeAmbiente)
    console.log("----------*******typeSeflie****-----------: ", typeSeflie)
    return (<GenericDialog open={props.open} onClose={props.closeAction}
        // title="Evidencia - Ubicación"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            height: '80vh',
            m: 2,
            flexDirection: 'column',
        }}>
            {typeAmbiente?.Value == "" || typeAmbiente?.Value == "IDRND" ? (
                <Box sx={{
                    display: 'flex', alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignContent: 'center',
                    mb: 1,
                    height: windowHeight > 900 ? "74vh" :
                        windowHeight > 800 ? "68vh" :
                            windowHeight > 700 ? "65vh" :
                                windowHeight < 600 ? "64vh"
                                    : "72vh"
                }}>
                    {console.log("windowHeight***********: ", windowHeight)}
                    <Typography variant="h6" >
                      {t("identity_selfie")}
                    </Typography>
                    <UseImage
                        src={iconLifet1Img}
                        width={!matches ? windowHeight > 900 ? 245
                            : windowHeight > 800 ? 230
                                : 195
                            : windowHeight > 800 ? 225 : 135}
                    />
                    <Typography variant="subtitle" align='center' sx={{
                        padding: '0.5em 0'
                    }} >
                      {t("identity_selfie_instructions")}
                    </Typography>
                </Box>
            ) : typeAmbiente?.Value == "Techub" ? (
                typeSeflie?.Value === '2' ? (
                    <Box ref={ref} className={localStyles.swiper}>
                        <Box key={1} sx={{ display: 'flex', alignItems: 'center', alignContent: 'center', flexDirection: 'column', mb: 5 }} >
                            <Typography variant="h6" >
                              {t("identity_selfie")}
                            </Typography>
                            <UseImage
                                src={iconLifet1Img}
                                width={!matches ? 200 : 175.64}
                            />
                            <Typography variant="subtitle" align='center' sx={{
                                padding: '0.5em 0'
                            }} >
                              {t("identity_selfie_instructions")}
                            </Typography>
                        </Box>
                        <Box key={2} sx={{ display: 'flex', alignItems: 'center', alignContent: 'center', flexDirection: 'column', mb: 5 }} >
                            <Typography variant="h6">
                                Prueba de vida
                            </Typography>
                            <UseImage
                                src={pruebaVidaSonrieImg}
                                width={!matches ? 200 : 175.64}
                            />
                            <Typography variant="subtitle" align='center' sx={{
                                padding: '0.5em 0'
                            }} >
                                El sistema te pedirá un gesto a realizar, haz el gesto y presiona el botón capturar
                            </Typography>
                        </Box>
                    </Box>
                ) : (
                    <Box ref={ref} className={localStyles.swiper}>
                        <Typography variant="h6" >
                          {t("identity_selfie")}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', alignContent: 'center', flexDirection: 'column', mb: 5 }} >
                            <UseImage
                                src={pruebaVidaSonrieImg}
                                width={!matches ? 200 : 175.64}
                            />
                        </Box>
                        <Typography variant="subtitle" align='center' sx={{
                            padding: '0.5em 0'
                        }} >
                            El sistema te pedirá un gesto a realizar, haz el gesto y presiona el botón capturar
                        </Typography>
                    </Box>
                )) : null
            }
            <Buttons
                ConfirmButtonText='Continuar'
                onClickConfirm={props.closeAction}
            />
        </Box>}
    />)
}